import { render, staticRenderFns } from "./GiveUpSettlement.vue?vue&type=template&id=7ffb5a45&"
import script from "./GiveUpSettlement.vue?vue&type=script&lang=js&"
export * from "./GiveUpSettlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports